module.exports = __webpack_public_path__ + "img/helpS.ea814d92.png";